/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import { Button, IconButton } from '@material-ui/core';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { IoSaveOutline } from 'react-icons/io5';
import { BsPlus } from 'react-icons/bs';
import { useHistory } from 'react-router-dom';
import Back from '../../assets/back.png';
import Home from '../../assets/home.png';
import color from '../../constants/color';
import icons from '../../constants/icons';
import {
  ContainerRow,
  DropDown,
  Img,
  Nav,
  OnPress,
  Route,
  Card,
  Row,
  Span,
} from './styles';

interface Props {
  isSave?: boolean;
  onBack: Function;
  onChange: any;
  onSave?: Function;
  hasOnChange?: boolean;
  showDrop?: boolean;
  options?: JSX.Element;
  open?: boolean;
  setOpen?: Function;
  breadcrumbs: Array<{
    path: string,
    name: string
  }>;
  loading?: boolean;
}
const navCommon: React.FC<Props> = ({
  onBack,
  onChange,
  hasOnChange,
  open,
  setOpen,
  showDrop,
  options,
  breadcrumbs,
  isSave,
  onSave,
  loading,
}) => {
  const history = useHistory();
  return (
    <Card>
      <ContainerRow>
        <Row>
          <IconButton
            onClick={() => {
              onBack();
            }}
            style={{ marginLeft: 20, marginRight: 6 }}
          >
            <img src={Back} alt="" />
          </IconButton>
          <IconButton onClick={() => history.replace({ pathname: '/menu' })}>
            <img src={Home} height={18} width={18} alt="" />
          </IconButton>
          <MdKeyboardArrowRight color="#919CAB" />
          <Nav separator="›" aria-label="breadcrumb">
            {breadcrumbs.map((item: { path: string, name: string }, index: number) => {
              if (!item.path) {
                return (
                  <Span>
                    {item.name}
                  </Span>
                );
              }
              return (
                <Route
                  to={item.path}
                  key={index.toString()}
                  color="inherit"
                >
                  {item.name}
                </Route>
              );
            })}
          </Nav>
        </Row>
        {hasOnChange && (
          <Row>
            <Button
              onClick={() => onChange(true)}
              style={{
                color: color.blue,
                marginRight: 8,
                fontWeight: 'normal',
              }}
              startIcon={<BsPlus />}
            >
              NOVO
            </Button>
            {showDrop ? (
              <OnPress onClick={() => setOpen && setOpen(!open)} aria-describedby="poper">
                <Img height={14} src={icons.pingIcon} />
              </OnPress>
            ) : null}
            {isSave && (
              <Button
                disabled={loading || false}
                onClick={() => onSave && onSave()}
                style={{
                  marginLeft: 4,
                  color: color.blue,
                  marginRight: 8,
                  fontWeight: 'normal',
                }}
                startIcon={<IoSaveOutline />}
              >
                SALVAR
              </Button>
            )}
          </Row>
        )}
      </ContainerRow>
      {open === true ? (
        <DropDown>
          {options}
        </DropDown>
      ) : null}
    </Card>
  );
};
export default navCommon;
